import * as _ from 'underscore';
import { BaseUIElement } from './baseUIElement';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class Row extends BaseUIElement {
	private uiElements: KnockoutObservableArray<BaseUIElement>;
	constructor(
		id: string,
		label: string,
		uiElements?: BaseUIElement[] | KnockoutObservableArray<BaseUIElement>,
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				template: Templates.layouts_uiElements_row
			},
			options || {}
		);
		super(id, label, options);
		this.uiElements = ko.isObservable(uiElements)
			? <KnockoutObservableArray<BaseUIElement>>uiElements
			: _.isUndefined(uiElements)
				? ko.observableArray<BaseUIElement>()
				: ko.observableArray<BaseUIElement>(<BaseUIElement[]>uiElements);
	}
	public push(uiElement: BaseUIElement) {
		this.uiElements.push(uiElement);
	}
}
